import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ILocation } from '@/utils/types'

export default function useSeo(filterString?: string, location?: ILocation) {
  const globalStore = useGlobalStore()
  globalStore.setBreadcrumbs([{ title: '百貨專櫃據點', isActive: true, url: '/locations' }])

  const title = location?.id ? `${location?.seo?.meta_title}｜百貨專櫃據點` : `百貨專櫃據點`
  const description = location?.id ? globalStore.seoDescriptions.locaion.replace(':name', location.subject) : globalStore.seoDescriptions.locaion
  const canonical = location?.id ? `locations/${location.id}` : `locations?${filterString ?? ''}`

  useSeoMeta({
    title: `${title}｜${import.meta.env.VITE_WEBSITE_TITLE}`,
    ogTitle: `${title}｜${import.meta.env.VITE_WEBSITE_TITLE}`,
    description: description,
    ogDescription: description,
    ogImage: location?.seo?.og_image?.link
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: `${import.meta.env.VITE_DOMAIN}/${canonical}`
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '百貨專櫃據點',
            item: `${import.meta.env.VITE_DOMAIN}/locations`
          }
        ]
      }
    ]
  })
}
